var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.svg#star--/Ko5F';
                    var viewUrl = 'sprites.svg#view-star--/Ko5F';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 15 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };